import React from 'react';

import { AutoCompleteProps as AntdAutoCompleteProps } from 'antd';

import {
  AdresseApiGouvOption,
  useSearchAdresseApiGouv,
} from 'hooks/search/useSearchAdresseApiGouv';
import { makeReadable } from 'utils/makeReadable';

import BaseAutocomplete, { AutocompleteDependencies } from './BaseAutocomplete';

interface AutocompleteAdresseProps
  extends Omit<
    AntdAutoCompleteProps<string, AdresseApiGouvOption>,
    'options' | 'name'
  > {
  codePostalField?: string;
  communeField?: string;
  name: string;
}

function buildValue(option: AdresseApiGouvOption): string {
  return `${option.adresse} ${
    option.codepostal || option.commune ? '-' : ''
  } ${makeReadable(option.codepostal)} ${makeReadable(option.commune)}`.trim();
}

export default function AutocompleteAdresse<FormValues>({
  codePostalField,
  communeField,
  name,
  onChange: _onChange,
  ...props
}: AutocompleteAdresseProps): React.ReactElement {
  const dependents: AutocompleteDependencies<
    FormValues,
    AdresseApiGouvOption
  >[] = [];

  if (codePostalField) {
    dependents.push({
      name: codePostalField,
      getValue: option => option.codepostal,
    });
  }

  if (communeField) {
    dependents.push({
      name: communeField,
      getValue: option => option.commune,
    });
  }

  return (
    <BaseAutocomplete<FormValues, AdresseApiGouvOption>
      {...props}
      optionsFetcher={useSearchAdresseApiGouv}
      buildValue={buildValue}
      getCurrentFieldValue={option => option.adresse}
      name={name}
      dependencies={dependents}
    />
  );
}
